import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-content-panel-styles',
  templateUrl: './styles.component.html',
  styleUrls: ['./styles.component.less']
})
export class StylesComponent implements OnInit {
  backgroundColor = '#ffffff';
  defaultBackgroundColor = '#ffffff';
  defaultHeaderBackgroundColor = '#ffffff';
  defaultHeaderHoverColor = '#ffffff';
  defaultHeaderTextColor = '#000000';
  headerBackgroundColor = '#ffffff';
  headerHoverColor = '#ffffff';
  headerTextColor = '#000000';
  uploaded: Object = {favicon: null, header: null, logo: null, wallpaper: null};

  constructor() { }

  ngOnInit() { }

  resetBackgroundColor() {
    this.backgroundColor = this.defaultBackgroundColor;
  }

  resetHeaderBackgroundColor() {
    this.headerBackgroundColor = this.defaultHeaderBackgroundColor;
  }

  resetHeaderHoverColor() {
    this.headerHoverColor = this.defaultHeaderHoverColor;
  }

  resetHeaderTextColor() {
    this.headerTextColor = this.defaultHeaderTextColor;
  }

  resetFile(name) {
    this.uploaded[name] = null;
  }

  setFile(params) {
    this.uploaded[params.name] = {title: params.file.name, blob: URL.createObjectURL(params.file)};
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/content-panel/styles/styles.component.ts